import React from 'react';
import PropTypes from 'prop-types';

import { ImageContent } from './style';

const filterChildren = (children, predicate) => children.reduce((current, child) => {
  if (child && predicate(child)) {
    return child;
  }

  return current;
}, null);

class ResponsiveImage extends React.Component {
  constructor(props) {
    super(props);

    // used by React as the component name
    this.displayName = 'ResponsiveImage';

    // bind 'this' to functions
    this.getInitialSize = this.getInitialSize.bind(this);
    this.onResize = this.onResize.bind(this);
    this.getCurrentSizeClone = this.getCurrentSizeClone.bind(this);

    // initial state object
    this.state = {
      currentImageSize: this.getInitialSize(),
      windowSize: {
        width: 0,
        height: 0,
      },
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const { children } = this.props;
    const windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    const currentImageSize = filterChildren(children, child => (
      windowSize.width >= child.props.minWidth
    ));

    this.setState({
      windowSize,
      currentImageSize,
    });
  }

  getInitialSize() {
    const { children } = this.props;

    let initialSize = filterChildren(children, child => (
      child.props.default || window.innerWidth >= child.props.minWidth
    ));

    if (!initialSize) {
      const [first] = children;
      initialSize = first;
    }

    return initialSize;
  }

  getCurrentSizeClone() {
    const {
      alt,
      background,
      imageStyle,
    } = this.props;

    const {
      currentImageSize,
      windowSize,
    } = this.state;

    return React.cloneElement(currentImageSize, {
      alt,
      background,
      key: `image-size-${currentImageSize.props.minWidth}`,
      parentImageStyle: imageStyle,
      windowSize,
    });
  }

  render() {
    const { className } = this.props;
    const currentSizeClone = this.getCurrentSizeClone();
    const additionalClass = className
      ? ` ${className}` : '';
    const newClassName = `component-responsive-image${additionalClass}`;

    return (
      <ImageContent className={newClassName}>{currentSizeClone}</ImageContent>
    );
  }
}

ResponsiveImage.propTypes = {
  alt: PropTypes.string,
  background: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  className: PropTypes.string,
  imageStyle: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
};

ResponsiveImage.defaultProps = {
  alt: '',
  background: false,
  children: '',
  className: '',
  imageStyle: {},
};

export default ResponsiveImage;
